import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Adim from "./Adim";
import { useDispatch, useSelector } from "react-redux";
import { sendCode } from "../../redux/actions";
import Button from "./Button";

const Onay = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [formError, setFormError] = useState(null);
  const location = useLocation();
  const { loading, error } = useSelector((state) => state.auth);
  const email =
    location.state?.email || localStorage.getItem("pendingEmail") || "";
  const name = location.state?.name || "";

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      // Önceki inputa geç ve içeriğini temizle
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError(null);

    const enteredCode = otp.join("");
    const dataToSend = { email, verificationCode: enteredCode };
    try {
      await dispatch(sendCode(dataToSend)).unwrap();
      // Kayıt başarılıysa email bilgisini localStorage'dan sil
      localStorage.removeItem("pendingEmail");
      navigate("/kariyer_bilgileri", {
        state: {
          email,
          name,
        },
      });
    } catch (error) {
      setFormError(
        error.message || "Onay kodu doğrulama başarısız. Tekrar deneyin."
      );
    }
  };
  return (
    <form className="form-container h-[597px] gap-8" onSubmit={handleSubmit}>
      <div className="flex flex-col justify-between items-center h-full gap-8">
        <p className="text-base font-normal text-grayy leading-6 text-center">
          6 haneli bir onay kodunu e-posta ile gönderdik. E-postanızı doğrulamak
          için lütfen kutuya kodu girin.
        </p>
        <div className="flex gap-2">
          {otp.map((data, index) => (
            <input
              key={index}
              id={`otp-input-${index}`}
              type="text"
              maxLength="1"
              value={otp[index]}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="w-11 h-11 sm:w-12 sm:h-12 text-center border border-gray-300 rounded-md text-lg"
            />
          ))}
        </div>
        <div className="flex flex-col gap-4 w-full">
          <Button loading={loading} />
          {(error || formError) && (
            <p className="text-red-500">{error || formError}</p>
          )}
          <Adim page="onay" />
        </div>
      </div>
    </form>
  );
};

export default Onay;
